import script from "./PauseProModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PauseProModal.vue?vue&type=script&setup=true&lang=ts"

import "./PauseProModal.vue?vue&type=style&index=0&id=227c72ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227c72ce"]])

export default __exports__